import { createAppAsyncThunk } from 'reduxTyped'
import { InvitationData } from 'common/userRoles/userRolesInterfaces'
import { handleError } from 'shared/api/lib/errors/handlers'
import { AuthApi } from 'shared/api/requests/auth'

interface GetInvitationDataResponse {
  data?: InvitationData | null
}

interface ProcessInvitationResponse {
  onboarding_status: boolean
  optin_required: boolean
  optin_payload?: string
}

export const getInvitationData = createAppAsyncThunk<GetInvitationDataResponse, string>(
  'invitation/getInvitationData',
  async (code, { rejectWithValue }) => {
    try {
      const { data } = await AuthApi.getInvitationData({
        query: {
          code,
        },
      })

      return data as GetInvitationDataResponse
    } catch (error) {
      handleError(error)

      return rejectWithValue()
    }
  },
)

export const acceptInvitation = createAppAsyncThunk<ProcessInvitationResponse, string>(
  'invitation/acceptInvitation',
  async (code, { rejectWithValue }) => {
    try {
      const { data } = await AuthApi.processInvitation({
        body: {
          code,
        },
      })

      return data as ProcessInvitationResponse
    } catch (error) {
      handleError(error)

      return rejectWithValue()
    }
  },
)
